module.exports = __webpack_public_path__ + "static/media/vero_green_transparentv2.d65df3a2.png";